import React, { useState } from "react";
import tableup from "../../../../assets/tableup.svg";
import tabledown from "../../../../assets/tabledown.svg";
import { Accordion, Modal } from "react-bootstrap";
import CopyToClipboard from "react-copy-to-clipboard";
import moment from 'moment';
import ReactPaginate from "react-paginate";

const DataTable = ({ activityLogs, pagination, onPageChange }) => {
  // console.log(pagination, 'paginationpagination');
  
  const renderPagination = () => {
    if (!pagination || pagination.totalPages <= 1) return null;

    const handlePageChange = (event) => {
      onPageChange(event.selected + 1); // ReactPaginate's page index is 0-based
    };

    return (
      <div className="footer-content">
           <div className="left-f">
              {/* <h6>SHOWING 1-10 OF 145</h6> */}
              {/* <h6>SHOWING 1-10 OF 145</h6> */}
            </div>
      <div className="right-f">
        <nav aria-label="Page navigation example">
          <ul className="pagination">
            <ReactPaginate
              previousLabel={
               <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17"
                            height="16"
                            viewBox="0 0 17 16"
                            fill="none"
                          >
                            <path
                              d="M7.88904 1.93555L5.38763 1.93555L1.99459 7.99682L4.496 7.99682L7.88904 1.93555Z"
                              fill="#329879"
                            />
                            <path
                              d="M7.88904 14.0703L5.38763 14.0703L1.99459 8.00904L3.57108 6.96117L4.496 8.00904L7.88904 14.0703Z"
                              fill="#329879"
                            />
                            <path
                              d="M8.01655 6.85742H14.9616L13.6869 9.14313H6.74182L8.01655 6.85742Z"
                              fill="#329879"
                            />
                          </svg>
              }
              nextLabel={
                  <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17"
                            height="16"
                            viewBox="0 0 17 16"
                            fill="none"
                          >
                            <path
                              d="M9.11108 1.93555L11.6125 1.93555L15.0055 7.99682L12.5041 7.99682L9.11108 1.93555Z"
                              fill="#329879"
                            />
                            <path
                              d="M9.11108 14.0703L11.6125 14.0703L15.0055 8.00904L13.429 6.96117L12.5041 8.00904L9.11108 14.0703Z"
                              fill="#329879"
                            />
                            <path
                              d="M3.31318 6.85742H10.2582L8.98351 9.14313H2.03845L3.31318 6.85742Z"
                              fill="#329879"
                            />
                          </svg>
              }
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              breakLabel="..."
              breakClassName="page-item"
              breakLinkClassName="page-link"
              pageCount={pagination.totalPages}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={handlePageChange}
              containerClassName="pagination"
              activeClassName="active"
              forcePage={pagination.currentPage - 1} // ReactPaginate's page index is 0-based
            />
          </ul>
        </nav>
      </div>
      </div>
    );
  };
  return (
    <>
      <section className="datatable">
        <div className="tabled-noneformobile table-responsive justmobiled-none">
          <table className="table">
            <thead>
              <tr>
                <th>
                  <div
                    className="parent-tag"
                    style={{ cursor: "pointer" }}
                  >
                    Date
                    <div className="filter-btn">
                      {/* <svg
                        width="9"
                        height="6"
                        viewBox="0 0 9 6"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.90908 5.14282H4.09498H0.660442C0.072714 5.14282 -0.22115 4.36222 0.195157 3.90463L3.36644 0.418863C3.87458 -0.139668 4.70107 -0.139668 5.20921 0.418863L6.41528 1.74453L8.38049 3.90463C8.79068 4.36222 8.49681 5.14282 7.90908 5.14282Z"
                          fill="#77868B"
                        />
                      </svg>
                      <svg
                        width="9"
                        height="6"
                        viewBox="0 0 9 6"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.90908 0.857178H4.09498H0.660442C0.072714 0.857178 -0.22115 1.63778 0.195157 2.09537L3.36644 5.58114C3.87458 6.13967 4.70107 6.13967 5.20921 5.58114L6.41528 4.25547L8.38049 2.09537C8.79068 1.63778 8.49681 0.857178 7.90908 0.857178Z"
                          fill="#77868B"
                        />
                      </svg> */}
                    </div>
                  </div>
                </th>
                <th>
                  <div
                    className="parent-tag"
                    style={{ cursor: "pointer" }}
                  >
                    User
                  </div>
                </th>
                <th>
                  <div
                    className="parent-tag"
                    style={{ cursor: "pointer" }}
                  >
                    Activity
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {activityLogs &&
                activityLogs.map((log) => (
                  <tr key={log._id}>
                    <td>
                      <div className="twice-text">
                        <h6>{moment(log.createdAt).format("DD/MM/YYYY")}</h6>
                        <p>{moment(log.createdAt).format("H:mm")}</p>
                      </div>
                    </td>
                    <td>{log.adminName}</td>
                    <td>{log.activity}</td>
                  </tr>
                ))}
              {!activityLogs || activityLogs.length === 0 && (
                <tr>
                  <td colSpan="3">No activity logs found.</td>
                </tr>
              )}
            </tbody>
          </table>
          {renderPagination()}
        </div>
        <div className="accmblviewfdsasdf d-none">
          <div className="main-twice-text">
            <h6 className="accmblviewhead">Date</h6>
          </div>
          <Accordion>
            {activityLogs &&
              activityLogs.map((log) => (
                <Accordion.Item key={log._id}>
                  <Accordion.Header>
                    <div className="accheadermain">
                      <div className="twice-text">
                        <h6 style={{ color: "#000" }}>
                          {moment(log.createdAt).format("DD/MM/YYYY")}
                        </h6>
                        <p style={{ color: "#000" }}>
                          {moment(log.createdAt).format("H:mm")}
                        </p>
                      </div>
                    </div>
                  </Accordion.Header>
                  <Accordion.Body>
                    <div className="acctexts">
                      <h6 className="textleft">User</h6>
                      <p className="textright">{log.adminName}</p>
                    </div>
                    <div className="acctexts">
                      <h6 className="textleft">Activity</h6>
                      <p
                        className="textright"
                        style={{ textAlign: "right" , fontSize : '10px' , lineHeight : '16px' , wordBreak : 'break-word' }}
                      >
                        {log.activity}
                      </p>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            {!activityLogs || activityLogs.length === 0 && (
              <Accordion.Item>
                <Accordion.Header>No activity logs</Accordion.Header>
                <Accordion.Body>No activity logs found.</Accordion.Body>
              </Accordion.Item>
            )}
          </Accordion>
          {renderPagination()}
        </div>
      
      </section>
    
    </>
  );
};

export default DataTable;